export const isCollidersVisible = false;

export const states = {
  loadManifest: { availableStates: ['loadingSettings'], nextState: 'loadingSettings' },
  loadingSettings: { availableStates: ['loading'], nextState: 'loading' },
  loading: { availableStates: ['loadComplete'] },
  loadComplete: { availableStates: ['initialization'] },
  initialization: { availableStates: ['initializationComplete'], nextState: 'initializationComplete' },
  initializationComplete: { availableStates: ['initLevel'], nextState: 'initLevel' },
  initLevel: { availableStates: ['initLevelComplete'], nextState: 'initLevelComplete' },
  initLevelComplete: { availableStates: ['showing'], nextState: 'showing' },
  gameTutorial: { availableStates: ['showing'], nextState: 'showing' },
  showing: { availableStates: ['showingComplete'] },
  showingComplete: { availableStates: ['countdown'] },
  countdown: { availableStates: ['playing'] },
  playing: { availableStates: ['losing', 'winning', 'boosterTutorial', 'paused'] },
  boosterTutorial: { availableStates: ['countdown'] },
  paused: { availableStates: ['playing', 'gameTutorial'] },
  losing: { availableStates: ['lose', 'paused', 'playing'] },
  lose: { availableStates: ['reset', 'main', 'initLevel'] },
  winning: { availableStates: ['win', 'paused', 'playing'] },
  win: { availableStates: ['reset', 'main', 'initLevel'] },
  reset: { availableStates: ['initialization'], nextState: 'initialization' },
};

export const hiddenSceneStates = [
  'loadManifest',
  'loadingSettings',
  'loading',
  'loadComplete',
  'initialization',
  'initializationComplete',
  'initLevel',
  'initLevelComplete',
];

export const ignoreNextStates = [
  'main',
  'boosterTutorial',
  'gameTutorial',
  'loadLevel',
  'showing',
  'rating',
  'help',
  'tutorial',
  'name',
  'question',
  'prizes',
  'countdown',
  'playing',
  'lose',
  'paused',
  'win',
];

export const itemsSize = { maxScale: 1, minScale: 0.74, maxFillSize: { width: 50, height: 50 } };

export const gameControlsData = {
  plugins: ['KeyboardPlugin'],
  selectors: { KeyboardPlugin: '.game' },
  controls: [
    {
      name: 'left',
      keyboard: { keys: [{ keyCode: 37 }, { keyCode: 65 }] },
    },
    {
      name: 'right',
      keyboard: { keys: [{ keyCode: 39 }, { keyCode: 68 }] },
    },
  ],
};

export const types = [
  { type: 'enemy', generationChance: 0.2 },
  { type: 'stuff', generationChance: 0.5 },
  { type: 'booster', generationChance: 0.1 },
  { type: 'coin', generationChance: 0.2 },
];

export const itemsData = {
  enemy: [{ type: 'enemy', name: 'enemy1', width: 50, height: 50, speed: 33, collider: { type: 'rect' } }],
  stuff: [
    { type: 'stuff', name: 'item1', width: 50, height: 50, speed: 17, collider: { type: 'rect' } },
    { type: 'stuff', name: 'item2', width: 50, height: 50, speed: 17, collider: { type: 'rect' } },
    { type: 'stuff', name: 'item3', width: 50, height: 50, speed: 17, collider: { type: 'rect' } },
    { type: 'stuff', name: 'item4', width: 50, height: 50, speed: 17, collider: { type: 'rect' } },
    { type: 'stuff', name: 'item5', width: 50, height: 50, speed: 17, collider: { type: 'rect' } },
  ],
  booster: [
    { type: 'booster', name: 'magnet', width: 50, height: 50, speed: 33, timeout: 5, collider: { type: 'rect' } },
    { type: 'booster', name: 'reverse', width: 50, height: 50, speed: 33, timeout: 5, collider: { type: 'rect' } },
    {
      type: 'booster',
      name: 'infection',
      width: 50,
      height: 50,
      speed: 33,
      timeout: 5,
      collider: { type: 'rect' },
    },
    {
      type: 'booster',
      name: 'big_basket',
      width: 50,
      height: 50,
      speed: 33,
      timeout: 5,
      collider: { type: 'rect' },
    },
  ],
  coin: [{ type: 'coin', name: 'coin', width: 50, height: 50, speed: 33, collider: { type: 'rect' } }],
};

export const BASE_SETTINGS = {
  width: 360,
  height: 640,
  speed: 277,
  baseSize: { width: 360, height: 640 },
  interfaceOffsetX: 0,
  ground: { width: 360, height: 50, position: { x: 225, y: 580 } },
  background: { position: { x: 112, y: 0 } },
};

export const heroStates = ['waiting', 'moving'];

export const heroSettings = {
  gap: 10,
  width: 132,
  height: 85.5,
  lifes: 1,
  logo: 'basket_logo',
  top: 'basket_top',
  bottom: 'basket_bottom',
  name: 'hero',
  moveOffset: 100,
  yOffset: 0,
  paddingBottom: 30,
  rotationSpeed: 0.1,
  collider: {
    type: 'rect',
    width: 90,
    height: 4,
  },
};

export const collisionTypes = ['hero', 'enemy', 'stuff', 'booster', 'coin'];

// Анимации
export const fallAnimationTime = 0.3;
export const fallAnimationDelta = 0.2;
export const explosionAnimationTime = 0.2;
export const gotDamageAnimationTime = 1;

const generalAnimation = {
  stuffDelay: 3000,
  maxDelay: 1000,
  minDelay: 300,
  maxAnimationTime: 0.5,
  collideAnimationTime: 0.8,
};

export const animations = {
  general: {
    ...generalAnimation,
  },
  magnet: {
    ...generalAnimation,
    collideAnimationTime: 1.2,
  },
};

export const generatorItemsRotationData = { minValue: 200, maxValue: 300 };
